<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/reportList/">Reports</a></li>
      <li *ngIf="type == 'Order Detail'" class="breadcrumb-item active" aria-current="page">Order Detail</li>
      <li *ngIf="type == 'Demand by SKU'" class="breadcrumb-item active" aria-current="page">Demand by SKU</li>
      <li *ngIf="type == 'Product Sales'" class="breadcrumb-item active" aria-current="page">Product Sales</li>
      <li *ngIf="type == 'Low Stock Report'" class="breadcrumb-item active" aria-current="page">Low Stock Report</li>
      <li *ngIf="type == 'Out Of Stock Report'" class="breadcrumb-item active" aria-current="page">Out Of Stock Report
      </li>
      <li *ngIf="type == 'Stock Status Report'" class="breadcrumb-item active" aria-current="page">Stock Status Report
      </li>
      <li *ngIf="type == 'Returned Products list'" class="breadcrumb-item active" aria-current="page">Returned Products
        list
      </li>
      <li *ngIf="type == 'Account Snapshot'" class="breadcrumb-item active" aria-current="page">Account Snapshot</li>
      <li *ngIf="type == 'Products'" class="breadcrumb-item active" aria-current="page">Products</li>
      <li *ngIf="type == 'Order all details'" class="breadcrumb-item active" aria-current="page">Order all details</li>
      <li *ngIf="type == 'Customer details'" class="breadcrumb-item active" aria-current="page">Customer details</li>
      <li *ngIf="type == 'Inventory Adjustments'" class="breadcrumb-item active" aria-current="page">Inventory
        Adjustments
      </li>
      <li *ngIf="type == 'Account Owner Details'" class="breadcrumb-item active" aria-current="page">Account Owner
        Details
      </li>
      <li *ngIf="type == 'Warehouse'" class="breadcrumb-item active" aria-current="page">
        Warehouse
      </li>
      <li *ngIf="type == 'Report'" class="breadcrumb-item active" aria-current="page">
        Report
      </li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <label class="mb-3" style="display: flex;"><span class="MobileContent"><i class="fa fa-arrow-left" routerLink="/admin/reportList"></i></span>&nbsp;&nbsp;<b>{{type}}</b></label>
          <div class="row">
            <div class="col-md-3"
                 *ngIf="type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list' && type !=='Account Snapshot' && type !=='Products' && type !=='Order all details' && type !=='Customer details' && type !=='Inventory Adjustments' && type !=='Warehouse' && type !=='Report'">
              <div class="form-group">
                <label class="control-label" for="sourceType">Source Type</label>
                <select class="form-control" id="sourceType" [(ngModel)]="sourceType"
                        [ngModelOptions]="{standalone: true}" required>
                  <option *ngFor="let i of channelList" [ngValue]="i.channels">{{i.channels | replaceStatus}}</option>
                </select>
              </div>
            </div>

<!--
            <div class="col-md-3"
                 *ngIf="type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list' && type !=='Order Detail' && type !=='Demand by SKU' && type !=='Product Sales' && type !=='Returned Products list' && type !=='Products' && type !=='Order all details' && type !=='Customer details' && type !=='Inventory Adjustments' && type !=='Warehouse' && type !=='Report'">
              <div class="form-group required">
                <label class="control-label" for="invoice">Invoice Type</label>
                <select class="form-control" id="invoice" [(ngModel)]="invoiceType"
                        [ngModelOptions]="{standalone: true}" required>
                  <option value="WORK_ORDER">Work Order</option>
                  <option value="FULFILLMENT">Fulfilment</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!invoiceTypeError">
                  {{invoiceTypeError}}
                </div>
              </div>
            </div>
-->


            <div class="col-md-3"
                 *ngIf="type !=='Order Detail' && type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'  && type !=='Account Snapshot'  && type !=='Products'  && type !=='Order all details'  && type !=='Inventory Adjustments' && type !=='Customer details' && type !=='Warehouse' && type !=='Report'">
              <div class="form-group required">
                <label class="control-label" for="orderStatus">Order Status</label>
                <select class="form-control" id="orderStatus" [(ngModel)]="orderStatus"
                        [ngModelOptions]="{standalone: true}" required>
                  <option value="SUBMITTED">Submitted</option>
                  <option value="SHIPPED">Shipped</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!orderStatusError">
                  {{orderStatusError}}
                </div>
              </div>
            </div>

            <div class="col-md-3" *ngIf="type ==='Customer details'">
              <div class="form-group required">
                <label class="control-label" for="status">Status</label>
                <select class="form-control" id="status" [(ngModel)]="status" [ngModelOptions]="{standalone: true}"
                        required>
                  <option value="ALL">All</option>
                  <option value="ACTIVE">Active</option>
                  <option value="IN_ACTIVE">In Active</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusError">{{statusError}}</div>
              </div>
            </div>

            <div class="col-md-3"
                 *ngIf="type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list' && type !=='Order Detail' && type !=='Demand by SKU' && type !=='Product Sales' && type !=='Returned Products list' && type !=='Products' && type !=='Order all details' && type !=='Customer details' && type !=='Inventory Adjustments' && type !=='Warehouse' && type !=='Report'">
              <div class="form-group">
                <label class="control-label" for="payment">Payment Status</label>
                <select class="form-control" id="payment" [(ngModel)]="paymentStatus"
                        [ngModelOptions]="{standalone: true}" required>
                  <option value="PAID">PAID</option>
                  <option value="UNPAID">Un Paid</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!paymentStatusError">
                  {{paymentStatusError}}
                </div>
              </div>
            </div>

            <div class="col-md-3" *ngIf="type ==='Warehouse' || type ==='Report'">
              <div class="form-group required">
                <label class="control-label" for="warehouseStatus">Warehouse Status</label>
                <select class="form-control" id="warehouseStatus" [(ngModel)]="warehouseStatus"
                        [ngModelOptions]="{standalone: true}" required>
                  <option value="ACTIVE">Active</option>
                  <option value="IN_ACTIVE">In Active</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!warehouseStatusError">
                  {{warehouseStatusError}}
                </div>
              </div>
            </div>

            <div class="col-md-3" *ngIf="type ==='Warehouse' || type ==='Report'">
              <div class="form-group required">
                <label class="control-label">State</label>
                <ng-select id="State" [(ngModel)]="state" [ngModelOptions]="{standalone: true}"
                           [ngClass]="{'service-error':stateError}"
                           [ngClass]="{'is-invalid':stateError}"
                           [items]="statesList"
                           placeholder="State">
                </ng-select>
<!--                <input type="text" id="state" [(ngModel)]="state" [ngModelOptions]="{standalone: true}"
                       class="form-control">-->
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!stateError">{{stateError}}</div>
              </div>
            </div>

            <div class="col-md-3" *ngIf="type ==='Warehouse' || type ==='Report'">
              <div class="form-group required">
                <label class="control-label" for="city">City</label>
                <input type="text" id="city" [(ngModel)]="city" [ngModelOptions]="{standalone: true}"
                       class="form-control">
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!cityError">{{cityError}}</div>
              </div>
            </div>

          </div>

          <div class="row"
               *ngIf="type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Inventory Adjustments' && type !=='Warehouse' && type !=='Report'">
            <div class="col-md-3">
              <div class="form-group required">
                <label class="control-label" for="fromDate">Start Date</label>
                <input type="date" id="fromDate" [(ngModel)]="startDate"
                       [ngModelOptions]="{standalone: true}"
                       class="form-control" value="1">
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!startDateError">
                  {{startDateError}}
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group required">
                <label class="control-label" for="toDate">End Date</label>
                <input type="date" id="toDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                       class="form-control" value="1">
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!endDateError">{{endDateError}}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6" style="padding-left: 30px;">
              <button type="button" routerLink="/admin/reportList" class="btn btn-cancel deskContent">Back</button>
            </div>
            <div class="col-md-6 text-right" style="padding-right: 30px;">
              <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
              <button type="submit" (click)="submitOrder()" class="btn btn-orange ml-2">Generate</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="type =='Order Detail'">
      <div class="col-12" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a placement="bottom" class="mr-2" ngbTooltip="Export To Pdf"  *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>tspan { white-space:pre }
                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX1()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
               <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
               &lt;!&ndash;
                     <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
               &ndash;&gt;
             </div>-->
            </div>
          </div>
          <div style="overflow: auto;">
          <table class="table" id="export">
            <tr>
              <th>Order#</th>
              <th>Channel Order#</th>
              <th>Seller Company Name</th>
              <th>Created Date</th>
              <th>Channel Name</th>
              <th>Status</th>
              <th>Sender Name</th>
              <th>Receiver Name</th>
              <th>Track Order</th>
            </tr>
            <tr *ngFor="let od of orderList">
              <td>{{od.orderNumber}}</td>
              <td>{{od.sourceOrderId || '--'}}</td>
              <td>{{od.sellerCompanyName || '--' }}</td>
              <td>{{od.createdDate}}</td>
              <td>{{od.connectionName | titlecase}}</td>
              <td>{{od.orderStatus | replaceStatus}}</td>
              <td>{{od.senderName}}</td>
              <td>{{od.receiverName}}</td>
              <td>
                <div
                  *ngIf="od.thirdPartyTrackingNum !== null">
                  <a routerLink="/trackOutboundOrder/{{od.orderHeaderId}}/{{od.accountOwnerId}}" target="_blank">
                    <img src="assets/images/dsBuffer.png" width="30" height="30" alt="trackImage">
                  </a>
                </div>
              </td>
            </tr>
          </table>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Demand by SKU'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2"></div>
            <a placement="bottom" class="mr-2" ngbTooltip="Export To Pdf"  *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" id="demandBySku" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              &lt;!&ndash;
                    <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
              &ndash;&gt;
            </div>-->
          </div>
          <div style="overflow: auto;">
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
            </tr>
            <tr *ngFor="let dbs of orderList">
              <td style="text-transform:uppercase;">{{dbs.sku}}</td>
              <td>{{dbs.productName}}</td>
              <td>{{dbs.productType}}</td>
              <td>{{dbs.ownerName}}</td>
              <td>{{dbs.channelName | titlecase}}</td>
            </tr>
          </table>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Product Sales'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a placement="bottom" ngbTooltip="Export To Pdf" class="mr-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" id="productSales" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              &lt;!&ndash;
                    <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
              &ndash;&gt;
            </div>-->
            </div>
          </div>
          <div style="overflow: auto"></div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
            </tr>
            <tr *ngFor="let rpl of orderList">
              <td style="text-transform:uppercase;">{{rpl.sku}}</td>
              <td>{{rpl.productName}}</td>
              <td>{{rpl.productType}}</td>
              <td>{{rpl.ownerName}}</td>
              <td>{{rpl.channelName | titlecase}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Returned Products list'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a placement="bottom" ngbTooltip="Export To Pdf" class="mr-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>tspan { white-space:pre }
                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel"  *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" id="returnProductsLists" width="30"
                   height="30" viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
               <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
               &lt;!&ndash;
                     <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
               &ndash;&gt;
             </div>-->
          </div>
          </div>
          <div style="overflow: auto;">
          <table class="table" >
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
            </tr>
            <tr *ngFor="let rpl of orderList">
              <td style="text-transform:uppercase;">{{rpl.sku}}</td>
              <td>{{rpl.productName}}</td>
              <td>{{rpl.productType}}</td>
              <td>{{rpl.ownerName}}</td>
              <td>{{rpl.channelName | titlecase}}</td>
            </tr>
          </table>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Inventory Reports'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">

          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Ordered Quantity</th>
              <th>Bin Location</th>
            </tr>
            <tr>
              <td style="text-transform:uppercase;">{{'l.sku'}}</td>
              <td>{{'l.productName'}}</td>
              <td>{{'l.quantity'}}</td>
              <td>{{'l.binLocation'}}</td>

            </tr>
          </table>

        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Low Stock Report'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-md-10">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
               <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
               &lt;!&ndash;
                     <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
               &ndash;&gt;
             </div>-->
          </div>
          <table class="table">
            <tr>
              <th>Warehouse</th>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Owner Name</th>
              <th>Stock Status</th>
            </tr>
            <ng-container *ngFor="let om of orderList">
              <tr *ngFor="let o of om.productsList">
                <td>{{om.warehouseName}}</td>
                <td style="text-transform:uppercase;">{{o.sku}}</td>
                <td>{{o.productName}}</td>
                <td>{{o.ownerName}}</td>
                <td>{{(o.stockStatus == 'LOW_STOCK' ? 'Low Stock': o.stockStatus )}}</td>
              </tr>
              <tr *ngIf="!om.productsList.length">
                <td>{{om.warehouseName}}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Out Of Stock Report'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-md-10">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
               <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
               &lt;!&ndash;
                     <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
               &ndash;&gt;
             </div>-->
          </div>
          <table class="table">
            <tr>
              <th>Warehouse</th>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Owner Name</th>
              <th>Stock Status</th>
            </tr>
            <ng-container *ngFor="let om of orderList">
              <tr *ngFor="let o of om.productsList">
                <td>{{om.warehouseName}}</td>
                <td style="text-transform:uppercase;">{{o.sku}}</td>
                <td>{{o.productName}}</td>
                <td>{{o.ownerName}}</td>
                <td>{{(o.stockStatus == 'OUT_OF_STOCK' ? 'Out Of Stock': o.stockStatus )}}</td>
              </tr>
              <tr *ngIf="!om.productsList.length">
                <td>{{om.warehouseName}}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>

            </ng-container>

          </table>

        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>


    <div class="row mt-3" *ngIf="type =='Shipments'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-11">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
               <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
               &lt;!&ndash;
                     <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
               &ndash;&gt;
             </div>-->
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Ordered Quantity</th>
              <th>Bin Location</th>
            </tr>
            <tr>
              <td style="text-transform:uppercase;">{{'l.sku'}}</td>
              <td>{{'l.productName'}}</td>
              <td>{{'l.quantity'}}</td>
              <td>{{'l.binLocation'}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Shipment Cost'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-11">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!--  <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
                <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
                &lt;!&ndash;
                      <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
                &ndash;&gt;
              </div>-->
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Ordered Quantity</th>
              <th>Bin Location</th>
            </tr>
            <tr>
              <td style="text-transform:uppercase;">{{'l.sku'}}</td>
              <td>{{'l.productName'}}</td>
              <td>{{'l.quantity'}}</td>
              <td>{{'l.binLocation'}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Shipped products'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-11">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              &lt;!&ndash;
                    <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
              &ndash;&gt;
            </div>-->
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Ordered Quantity</th>
              <th>Bin Location</th>
            </tr>
            <tr>
              <td style="text-transform:uppercase;">{{'l.sku'}}</td>
              <td>{{'l.productName'}}</td>
              <td>{{'l.quantity'}}</td>
              <td>{{'l.binLocation'}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Account Snapshot'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-11">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              &lt;!&ndash;
                    <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
              &ndash;&gt;
            </div>-->
          </div>
          <table class="table">
            <tr>
              <th>Invoice Number</th>
              <th>Invoice Date</th>
              <th>Invoice Type</th>
              <th>Customer Name</th>
              <th>Total Amount</th>
              <th>Payment Status</th>
            </tr>
            <tr *ngFor="let dbs of orderList">
              <td style="text-transform:uppercase;">{{dbs.invoiceNum}}</td>
              <td>{{dbs.invoiceDate}}</td>
              <td>{{dbs.invoiceType| titlecase}}</td>
              <td>{{dbs.ownerName}}</td>
              <td>{{dbs.totalAmountInFormat}}</td>
              <td>{{dbs.paymentStatus | titlecase}}</td>


            </tr>
          </table>

        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf="type =='Customer details'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-md-10">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
               <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
               &lt;!&ndash;
                     <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
               &ndash;&gt;
             </div>-->
          </div>
          <table class="table">
            <tr>
              <th>Owner Name</th>
              <th>Contact Company Name</th>
              <th>Contact Name</th>
              <th>Contact Mobile</th>
              <th>Contact Email</th>
            </tr>
            <tr *ngFor="let cd of orderList">
              <td>{{cd.ownerName}}</td>
              <td>{{cd.companyName}}</td>
              <td>{{cd.contactName}}</td>
              <td>{{cd.mobile}}</td>
              <td>{{cd.email}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Order all details'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-11">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
               <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
               &lt;!&ndash;
                     <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
               &ndash;&gt;
             </div>-->
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
              <th>Status</th>
            </tr>
            <tr *ngFor="let od of orderList">
              <td style="text-transform:uppercase;">{{od.sku}}</td>
              <td>{{od.productName}}</td>
              <td>{{od.productType}}</td>
              <td>{{od.ownerName}}</td>
              <td>{{od.channelName | titlecase}}</td>
              <td>{{od.stockStatus | titlecase}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf="type =='Products'">
      <div class="col" *ngIf="orderList?.length>0">
        <div class="inner-box">
          <div class="row">
            <div class="col-11">
              <label><b>Reports</b></label>
            </div>
            <a placement="bottom" ngbTooltip="Export To Pdf" class="col-1 text-right mb-2" *ngIf="orderList?.length">
              <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"
                   (click)="exportToPdf()" width="30" height="30">
                <defs>
                  <image width="30" height="30" id="img1"
                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAFRQTFRFj1C/ilW6ilS7ilW7ilS7iVS6mGrD2snq4tTutpXUxardoHXHp3/M////4tXu+PT7kV+/vZ/ZrorQ6d/z8er307/mxKndtZTU8On3ronQ28rqiVW7NTF50QAAABx0Uk5TEJ/v/7Cg////////////////////////////8CH+cl8AAACBSURBVHicxdPLDoMwDERRQyCQxOGRhpKW//9PWiQkFvawa+/2rMaSiaraaFVEjYqfWkJqaszmR2y7/pvzQWSOR34YA+R4cYnjOOkcmFnnI1Z49pATZp8gMz8AZ7dMbs4KZ07Pfl2LzNkyGlZe5Wa3zvY9nC3CUcX+yNvdE1GzAd0BK/AS0hzeArcAAAAASUVORK5CYII="/>
                </defs>
                <style>
		tspan { white-space:pre }

                </style>
                <use id="Background" href="#img1" x="0" y="0"/>
              </svg>
            </a>
            <a placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2" for="export"
               *ngIf="orderList?.length" style="text-align-last: center;">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30"
                   viewBox="0 0 30 30">
                <defs>
                  <style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style>
                </defs>
                <g transform="translate(4 2.5)">
                  <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
                  <path class="b"
                        d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                        transform="translate(3.386 5.171)"/>
                </g>
              </svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              &lt;!&ndash;
                    <button type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
              &ndash;&gt;
            </div>-->
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
              <th>Status</th>
            </tr>
            <tr *ngFor="let p of orderList">
              <td style="text-transform:uppercase;">{{p.sku}}</td>
              <td>{{p.productName}}</td>
              <td>{{p.productType}}</td>
              <td>{{p.ownerName}}</td>
              <td>{{p.channelName | titlecase}}</td>
              <td>{{(p.stockStatus == 'LOW_STOCK' ? 'Low Stock' : (p.stockStatus == 'OUT_OF_STOCK' ? 'Out Of Stock' :
                (p.stockStatus == 'IN_STOCK' ? 'In Stock' : p.stockStatus )))}}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>
  </form>
</section>

<!--
<form *ngIf = "type =='Demand by SKU'">
  <div class="row">
    <div class="col">
      <div class="inner-box">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <input type="date" id="fromDate" [(ngModel)]="startDate"
                     [ngModelOptions]="{standalone: true}"
                     class="form-control" value="1">
              <label class="control-label" for="fromDate">Start Date</label>
            </div>
            <div class="form-group">
              <select class="form-control" id="orderStatus" [(ngModel)]="orderStatus" [ngModelOptions]="{standalone: true}" required>
                <option value="SUBMITTED">Submitted</option>
                <option value="SHIPPED">Shipped</option>
              </select>
              <label class="control-label" for="orderStatus">Order Status</label>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <input type="date" id="toDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                     class="form-control" value="1">
              <label class="control-label" for="toDate">End Date</label>
            </div>
            <div class="form-group">
              <select class="form-control" id="sourceType" [(ngModel)]="sourceType" [ngModelOptions]="{standalone: true}" required>
                <option value="MAGENTO">Magento</option>
                <option value="AMAZON">Amazon</option>
                <option value="SHOPCLUES">ShopClues</option>
                <option value="FLIPKART">FlipKart</option>
                <option value="SHOPIFY">Shopify</option>
                <option value="EBAY">Ebay</option>
                <option value="WOOCOMMERCE">WooCommerce</option>
              </select>
              <label class="control-label" for="sourceType">Source Type</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
-->


<!--
<form *ngIf = "type =='Product Sales'">
  <div class="row">
    <div class="col">
      <div class="inner-box">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <input type="date" id="fromDate" [(ngModel)]="startDate"
                     [ngModelOptions]="{standalone: true}"
                     class="form-control" value="1">
              <label class="control-label" for="fromDate">Start Date</label>
            </div>
            <div class="form-group">
              <select class="form-control" id="sourceType" [(ngModel)]="sourceType" [ngModelOptions]="{standalone: true}" required>
                <option value="MAGENTO">Magento</option>
                <option value="AMAZON">Amazon</option>
                <option value="SHOPCLUES">ShopClues</option>
                <option value="FLIPKART">FlipKart</option>
                <option value="SHOPIFY">Shopify</option>
                <option value="EBAY">Ebay</option>
                <option value="WOOCOMMERCE">WooCommerce</option>
              </select>
              <label class="control-label" for="sourceType">Source Type</label>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <input type="date" id="toDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                     class="form-control" value="1">
              <label class="control-label" for="toDate">End Date</label>
            </div>
            <div class="form-group">
              <select class="form-control" id="orderStatus" [(ngModel)]="orderStatus" [ngModelOptions]="{standalone: true}" required>
                <option value="SUBMITTED">Submitted</option>
                <option value="SHIPPED">Shipped</option>
              </select>
              <label class="control-label" for="orderStatus">Order Status</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
-->


<!--
<form *ngIf = "type =='Returned Products list'">
  <div class="row">
    <div class="col">
      <div class="inner-box">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <input type="date" id="fromDate" [(ngModel)]="startDate"
                     [ngModelOptions]="{standalone: true}"
                     class="form-control" value="1">
              <label class="control-label" for="fromDate">Start Date</label>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <input type="date" id="toDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                     class="form-control" value="1">
              <label class="control-label" for="toDate">End Date</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<div *ngIf = "type !=='Order Detail'" class="row mt-3">
  <div class="col text-right">
    <button type="submit" class="btn btn-cancel" routerLink="/admin/reportList">Cancel</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitOrder()">Submit</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitOrder()">Submit</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitOrder()">Submit</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitOrder()">Submit</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitOrder()">Submit</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitOrder()">Submit</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitOrder()">Submit</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitOrder()">Submit</button>
  </div>
</div>
-->
